var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.625V4.625C18 3.522 17.103 2.625 16 2.625H14V0.625H12V2.625H6V0.625H4V2.625H2C0.897 2.625 0 3.522 0 4.625V18.625C0 19.728 0.897 20.625 2 20.625H16C17.103 20.625 18 19.728 18 18.625ZM6 16.625H4V14.625H6V16.625ZM6 12.625H4V10.625H6V12.625ZM10 16.625H8V14.625H10V16.625ZM10 12.625H8V10.625H10V12.625ZM14 16.625H12V14.625H14V16.625ZM14 12.625H12V10.625H14V12.625ZM16 7.625H2V5.625H16V7.625Z",
    fill: "#097E52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadCalendar);
export default __webpack_public_path__ + "static/media/head-calendar.8cd07d5a5e9160f7721cf43b06416c82.svg";
export { ForwardRef as ReactComponent };